import script from "./kbd-shift-letter.vue?vue&type=script&lang=ts&setup=true"
export * from "./kbd-shift-letter.vue?vue&type=script&lang=ts&setup=true"

import "./kbd-shift-letter.vue?vue&type=style&index=0&id=682c7fb4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682c7fb4"]])

export default __exports__